import { Dispatch, SetStateAction, useEffect, useRef } from 'react';
import DataMatrixInput from '../../components/form/DataMatrixInput.tsx';
import { BarcodeData } from './QuarantineMeds.tsx';

interface IProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  onScan: (data: BarcodeData) => void;
  isMutating: boolean;
}

const ManualQuarantineScanModal = ({
  isOpen,
  setIsOpen,
  onScan,
  isMutating,
}: IProps) => {
  const modalRef = useRef<HTMLDivElement>(null);
  const instanceRef = useRef<M.Modal | null>(null);

  useEffect(() => {
    if (!modalRef.current) return;

    instanceRef.current = M.Modal.init(modalRef.current, {
      onCloseEnd: () => setIsOpen(false),
      dismissible: false,
    });

    return () => {
      instanceRef.current?.destroy();
      instanceRef.current = null;
    };
  }, [setIsOpen]);

  useEffect(() => {
    const instance = instanceRef.current;
    if (!instance) return;

    if (isOpen) {
      instance.open();
    } else {
      instance.close();
    }
  }, [isOpen]);

  return (
    <div ref={modalRef} className="modal">
      <div className="modal-content">
        <div className="row">
          <h5 className="center">Manual Quarantine</h5>
          <div className="divider" />
        </div>

        <div
          className="row"
          style={{ textAlign: 'center', fontSize: '1.4rem' }}
        >
          Scan med barcode or enter serial number to submit med for quarantine.
          <br></br>
          <br></br>
        </div>

        <div className="row">
          <div className="input-field col s12 m12 l12">
            <DataMatrixInput
              id="quarantine-med-barcode-scanner"
              onScan={onScan}
              allowPassiveInput={true}
              isLoading={isMutating}
            />
            <label htmlFor="quarantine-med-barcode-scanner">
              Serial Number
            </label>
          </div>
        </div>

        <div className="row">
          <button
            className="btn-small red waves-effect waves-dark col s3 offset-m4 m4 "
            onClick={() => instanceRef.current?.close()}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ManualQuarantineScanModal;
